import {
    ATTEMPT_FETCH_ATHLETE_SESSIONS,
    ATTEMPT_FETCH_SESSION_DETAILS,
    UPDATE_ATHLETE_HISTORY_FILTER,
} from 'shared_redux/actions';

export const fetchAthleteSessions = (athleteId, summary = true) => ({
    type: ATTEMPT_FETCH_ATHLETE_SESSIONS,
    athleteId,
    summary,
});

export const fetchSessionDetails = (athleteId, sessionId) => ({
    type: ATTEMPT_FETCH_SESSION_DETAILS,
    athleteId,
    sessionId,
});

export const updateFilterDate = (date) => ({
    type: UPDATE_ATHLETE_HISTORY_FILTER,
    date,
});
